import { useInfiniteQuery } from '@tanstack/react-query';
import { InventoryFilterInput, PaginationInput } from '@api/gql/graphql';
import { InventoryQueryKeys } from '@Inventory/services/queryKeys';
import { API_LIST_LIMIT, FrontierService } from '@api';
import { inventoryPermissionsQueryDocument } from '@Inventory/services/gql';

export function useInventoryPermissions(
  resourceId: string,
  filter?: InventoryFilterInput,
  pagination?: PaginationInput,
) {
  return useInfiniteQuery(
    [InventoryQueryKeys.InventoryPermissions, resourceId, filter],
    async ({ pageParam = 0 }) => {
      const updatedPagination = {
        take: pagination?.take || API_LIST_LIMIT,
        offset: pageParam,
      };

      const response = await FrontierService.request(inventoryPermissionsQueryDocument, {
        filter: {
          query: `resource="${resourceId}"` + (filter?.query ? ` AND (${filter.query})` : ''),
        },
        pagination: updatedPagination,
      });

      return {
        data: response.inventoryPermissions.edges.map((edge) => edge.node),
        pagination: {
          limit: updatedPagination.take,
          offset: Number(pageParam),
          hasMore: response.inventoryPermissions.hasMore,
        },
      };
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.pagination.hasMore ? lastPage.pagination.offset + lastPage.pagination.limit : undefined,
      keepPreviousData: true,
    },
  );
}
